import { Link } from 'react-router-dom';
import './AboutPage.css';
import logoImg from '../pics/Logo.png';

const svgProps = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' };
const PhoneIcon = ({ size = 18 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 8.81a19.79 19.79 0 01-3.07-8.63A2 2 0 012 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.11 7.3a16 16 0 006.59 6.59l1.36-1.14a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14.92z"/></svg>);
const MapPinIcon = ({ size = 18 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>);
const ClockIcon = ({ size = 18 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>);
const StarIcon = ({ size = 18 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>);
const WrenchIcon = ({ size = 22 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>);
const LightningIcon = ({ size = 22 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>);
const AwardIcon = ({ size = 22 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>);
const ChatIcon = ({ size = 22 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>);
const DollarIcon = ({ size = 22 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>);
const ShieldIcon = ({ size = 22 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>);
const GiftIcon = ({ size = 22 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/></svg>);

const stats = [
  { num: '16+', label: 'Years of Experience' },
  { num: '1000+', label: 'Google Reviews' },
  { num: '5.0', label: 'Average Rating' },
  { num: '1000s', label: 'Devices Repaired' },
];

const values = [
  { icon: <WrenchIcon />, title: 'Honest Repairs', desc: 'We diagnose your device first and tell you upfront what it needs — no pressure, no upselling.' },
  { icon: <LightningIcon />, title: 'Fast Turnaround', desc: 'We value your time. Most repairs are done in 30–60 minutes so you can get back to your day.' },
  { icon: <AwardIcon />, title: 'Premium Quality', desc: 'We only use quality replacement parts that meet or exceed original manufacturer standards.' },
  { icon: <ChatIcon />, title: 'Customer First', desc: 'From your first call to device pickup, we make sure you are informed and happy every step.' },
  { icon: <DollarIcon />, title: 'Fair Prices', desc: 'We offer the best prices in the Dayton area — with no hidden fees or surprise charges.' },
  { icon: <ShieldIcon />, title: 'Backed by Warranty', desc: 'Every repair we do comes with a warranty, because we stand behind our work 100%.' },
];

export default function AboutPage() {
  return (
    <div className="about-page">
      <section className="page-hero">
        <div className="page-hero__container">
          <span className="page-hero__tag">Our Story</span>
          <h1 className="page-hero__title">About Fix'n More</h1>
          <p className="page-hero__sub">
            Huber Heights' most trusted phone repair shop — built on honesty,
            expertise, and a genuine passion for helping people stay connected.
          </p>
        </div>
      </section>

      {/* ── STATS ── */}
      <section className="about-stats">
        <div className="about-stats__container">
          {stats.map((s, i) => (
            <div className="about-stat" key={i}>
              <span className="about-stat__num">{s.num}</span>
              <span className="about-stat__label">{s.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── STORY ── */}
      <section className="about-story">
        <div className="about-story__container">
          <div className="about-story__content">
            <span className="about-tag">Our Story</span>
            <h2 className="about-h2">16+ Years of Fixing<br />What Others Can't</h2>
            <p className="about-p">
              Fix'n More started with a simple idea: give people in Huber Heights a repair shop
              they can actually trust. No overpriced quotes. No runaround. Just honest, fast, expert repairs.
            </p>
            <p className="about-p">
              With over 16 years of hands-on experience, we've seen and fixed it all — from the
              oldest flip phones to the newest flagship devices. Our technicians are passionate about
              what they do, and it shows in every repair we complete.
            </p>
            <p className="about-p">
              Located next to Marshall's in NorthPark Center, we're right in the heart of the community
              we serve. Walk in any day, and we'll treat your device like it's our own.
            </p>
          </div>

          <div className="about-story__card">
            <div className="about-story__shop-card">
              <img src={logoImg} alt="Fix'n More" className="about-story__shop-logo" />
              <div className="about-story__shop-info">
                <div className="about-story__shop-row">
                  <span className="about-story__shop-row-icon"><MapPinIcon size={15} /></span>
                  <span>8239 Troy Pike<br />Huber Heights, OH 45424</span>
                </div>
                <div className="about-story__shop-row">
                  <span className="about-story__shop-row-icon"><PhoneIcon size={15} /></span>
                  <a href="tel:9372350298">(937) 235-0298</a>
                </div>
                <div className="about-story__shop-row">
                  <span className="about-story__shop-row-icon"><ClockIcon size={15} /></span>
                  <span>Mon–Fri: 10 AM – 7 PM<br />Sat: 10 AM – 7 PM<br />Sun: 12 PM – 4 PM</span>
                </div>
                <div className="about-story__shop-row">
                  <span className="about-story__shop-row-icon"><StarIcon size={15} /></span>
                  <span>5 / 5 · 1000+ Google Reviews</span>
                </div>
              </div>
              <Link to="/contact" className="about-story__shop-btn">Get Directions →</Link>
            </div>
          </div>
        </div>
      </section>

      {/* ── VALUES ── */}
      <section className="about-values">
        <div className="about-values__container">
          <div className="about-values__header">
            <span className="about-tag about-tag--light">Our Values</span>
            <h2 className="about-h2 about-h2--light">What We Stand For</h2>
          </div>
          <div className="about-values__grid">
            {values.map((v, i) => (
              <div className="about-value-card" key={i}>
                <span className="about-value-card__icon">{v.icon}</span>
                <h3 className="about-value-card__title">{v.title}</h3>
                <p className="about-value-card__desc">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── OWNER MESSAGE ── */}
      <section className="about-message">
        <div className="about-message__container">
          <div className="about-message__quote">
            <div className="about-message__qmark">"</div>
            <blockquote className="about-message__text">
              We have 16+ years of experience preparing phones. We offer the best quality parts
              and best prices in town.
            </blockquote>
            <div className="about-message__author">
              <div className="about-message__avatar">FM</div>
              <div>
                <strong>The Fix'n More Team</strong>
                <span>Huber Heights, OH · Since 2008</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="about-cta">
        <div className="about-cta__container">
          <h2>Ready to Get Your Device Fixed?</h2>
          <p>Stop by the store or get an instant quote online — no appointment necessary.</p>
          <div className="about-cta__actions">
            <a href="tel:9372350298" className="about-cta__btn about-cta__btn--white">
              <PhoneIcon size={15} /> Call Now
            </a>
            <Link to="/quote" className="about-cta__btn about-cta__btn--outline">Get a Free Quote</Link>
            <Link to="/contact" className="about-cta__btn about-cta__btn--outline">Find Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
